module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Barone Consulting Inc..46e4facb.pdf";